import * as Redux from 'redux';
import appReducer from './app.reducer';
import promiseMiddlewareCreator from 'redux-promise-middleware';
import * as ReduxLogger from 'redux-logger';
import * as ReactRouterRedux from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { PRODUCTION } from './app.const';
import { persistStore } from 'redux-persist';

export const history = createHistory();

const loggerMiddleware = ReduxLogger.createLogger();
const routeMiddleware = ReactRouterRedux.routerMiddleware(history);
const promiseMiddleware = promiseMiddlewareCreator();

const middlewares: Array<Redux.Middleware> = process.env.NODE_ENV === PRODUCTION ?
  [routeMiddleware, promiseMiddleware] :
  [loggerMiddleware, routeMiddleware, promiseMiddleware];

export const mmsStore = Redux.createStore(
  appReducer,
  Redux.compose(Redux.applyMiddleware(...middlewares))
);

export const mmsPersistor = persistStore(mmsStore);



// WEBPACK FOOTER //
// ./src/app/app.config.tsx